(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mox-drop-countdown"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mox-drop-countdown'))customElements.define('mox-drop-countdown',class extends HTMLElement{
    connectedCallback(){
      clearInterval(this.timer);
      const deadline=Date.parse(this.dataset.end);
      const display=this.querySelector('[data-drop-time]');
      const ended=this.querySelector('[data-drop-ended]');
      if(!Number.isFinite(deadline)||!display)return;
      const update=()=>{
        const remaining=Math.max(0,Math.ceil((deadline-Date.now())/1000));
        const hours=Math.floor(remaining/3600);
        const minutes=Math.floor(remaining%3600/60);
        const seconds=remaining%60;
        display.textContent=[hours,minutes,seconds].map(value=>String(value).padStart(2,'0')).join(':');
        display.setAttribute('datetime','PT'+remaining+'S');
        ended.hidden=remaining>0;
        if(remaining===0)clearInterval(this.timer);
        return remaining;
      };
      if(update()>0)this.timer=setInterval(update,1000);
    }
    disconnectedCallback(){clearInterval(this.timer);}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mox-list-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  const norm = s => String(s || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[\u2018\u2019]/g, "'").replace(/\s+/g, ' ').trim().toLowerCase();
  const cardTitle = title => String(title || '').split(/ [—–|-] /)[0].replace(/\s*\(v\.\s*\d+\)$/i, '').trim();
  function distance(a,b) {
    a=norm(a); b=norm(b);
    let row=Array.from({length:b.length+1},(_,i)=>i);
    for(let i=1;i<=a.length;i++){
      const next=[i];
      for(let j=1;j<=b.length;j++) next[j]=Math.min(next[j-1]+1,row[j]+1,row[j-1]+(a[i-1]===b[j-1]?0:1));
      row=next;
    }
    return row[b.length];
  }
  function parseList(text) {
    const lines = text.split(/\r?\n/).map(s => s.trim()).filter(Boolean);
    if (!lines.length || lines.length > 200) throw Error('input_error');
    const entries = lines.map((raw, index) => {
      const m = raw.match(/^(\d{1,3})(?:\s*([xX\u00d7])\s+|\s+)(.+)$/);
      const quantity = m ? Number(m[1]) : 1, name = m ? m[3].trim() : raw;
      if (!quantity || name.length > 200) throw Error('input_error');
      return {name, quantity, explicit: !!m, marker: m ? (m[2] || '') : '', index};
    });
    if (entries.reduce((n,e) => n + e.quantity, 0) > 2000) throw Error('input_error');
    return entries;
  }
  const bag = (cart, token) => (cart.items || []).reduce((m,i) => {
    if (!token || i.properties?._mox_list === token) m[String(i.variant_id)] = (m[String(i.variant_id)] || 0) + i.quantity;
    return m;
  }, {});
  const stock = (v, cart) => v.available && v.tracked ? Math.max(0, Math.floor(Number(v.stock) || 0) - (cart[v.id] || 0)) : 0;
  function metadata(v) {
    const a = v.options || [], labels = (v.optionNames || []).map(norm);
    const pick = (terms, fallback = '') => {const i = labels.findIndex(s => terms.includes(s)); return String((i < 0 ? fallback : a[i]) || '');};
    const language = pick(['language', 'langue']), condition = pick(['condition', 'etat'], v.condition), finish = pick(['finish', 'finition', 'printing', 'version']);
    const l = norm(language), c = norm(condition), f = norm(finish);
    const lang = /^(fr|french|francais)/.test(l) ? 'fr' : /^(en|english|anglais)/.test(l) ? 'en' : l;
    let rank = 99;
    if (/^(mint|m)$/.test(c)) rank = 0;
    else if (/^(near mint|near-mint|nm)/.test(c)) rank = 1;
    else if (/^(excellent|ex)/.test(c)) rank = 2;
    else if (/^(good|gd|bon)/.test(c)) rank = 3;
    else if (/^(light|lp)/.test(c)) rank = 4;
    else if (/^(played|pl|heavy|hp)/.test(c)) rank = 5;
    else if (/^(poor|po|damaged|dmg)/.test(c)) rank = 6;
    const foil = !/non.?foil/.test(f) && /foil|etched/.test(f);
    return {language, condition, finish, lang, rank, foil};
  }
  function eligible(v, filters) {
    const m = metadata(v);
    return (filters.language === 'all' || (filters.language === 'fr-en' ? ['fr','en'].includes(m.lang) : m.lang === filters.language)) &&
      (filters.condition === 'all' || m.rank <= Number(filters.condition)) &&
      (filters.finish === 'all' || (filters.finish === 'foil' ? m.foil : !m.foil));
  }
  function missingText(entries, groups) {
    const covered = new Map(groups.map(g => [g.key, Math.min(g.quantity, g.added + (g.state === 'ok' ? g.capacity : 0))]));
    const out = [];
    for (const e of entries) {
      const available = covered.get(e.key) || 0, taken = Math.min(e.quantity, available), left = e.quantity - taken;
      covered.set(e.key, available - taken);
      if (left) {if(e.explicit) out.push(`${left}${e.marker} ${e.name}`); else for(let i=0;i<left;i++) out.push(e.name);}
    }
    return out.join('\n');
  }
  const matches = (title, names) => {
    const cardName = norm(title).split(/ [—–|-] /)[0].replace(/\s*\(v\.\s*\d+\)$/, '').trim();
    return names.some(n => cardName === norm(n));
  };
  class MoxMagicList extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      const config=this.querySelector('[data-config]');
      if(!config){this.initTimer=setTimeout(()=>{if(this.isConnected)this.connectedCallback();},20);return;}
      this.ready = true; this.cfg = JSON.parse(config.textContent);
      const decode = document.createElement('textarea');
      this.cfg.text = Object.fromEntries(Object.entries(this.cfg.text).map(([key, value]) => {decode.innerHTML = value; return [key, decode.value];}));
      this.entries = []; this.groups = []; this.cart = {items:[]}; this.memo = new Map();
      this.token = crypto.randomUUID(); this.busy = false; this.locked = false; this.nextScryfall = 0;
      this.$ = s => this.querySelector(s);
      this.t = (k, values={}) => Object.entries(values).reduce((s,[a,b]) => s.replaceAll(`{${a}}`, String(b)), this.cfg.text[k] || k);
      this.$('form').addEventListener('submit', e => {e.preventDefault(); this.search();});
      this.$('[data-example]').onclick = () => {
        if (this.busy || this.locked) return;
        this.$('textarea').value = this.cfg.locale.startsWith('fr') ? '2 Foudre\nSol Ring\n3x Contresort' : '2 Lightning Bolt\nSol Ring\n3x Counterspell';
        this.$('textarea').dispatchEvent(new Event('input', {bubbles:true}));
        this.search();
      };
      this.$('[data-cancel]').onclick = () => this.controller?.abort();
      this.$('[data-add-all]').onclick = () => this.add(this.groups.filter(g=>g.selected));
      this.$('[data-copy]').onclick = () => this.export(false);
      this.$('[data-download]').onclick = () => this.export(true);
      this.querySelectorAll('[data-filter]').forEach(el=>el.onchange=()=>{this.allocate(); this.render();});
      this.render();
    }
    disconnectedCallback(){clearTimeout(this.initTimer);this.controller?.abort();}
    say(key, values={}){this.$('[data-status]').textContent = this.t(key, values);}
    filters(){return Object.fromEntries([...this.querySelectorAll('[data-filter]')].map(el=>[el.dataset.filter, el.value]));}
    money(n){return new Intl.NumberFormat(this.cfg.locale, {style:'currency', currency:this.cart.currency || this.cfg.currency}).format(n/100);}
    async json(url, options={}) {
      const controller = new AbortController(), timer = setTimeout(()=>controller.abort(), 20000);
      const abort=()=>controller.abort(); this.controller?.signal.addEventListener('abort', abort, {once:true});
      try {
        const response = await fetch(url, {...options, signal:controller.signal, cache:'no-store', headers:{Accept:'application/json', ...(options.headers || {})}});
        let data; try {data=await response.json();} catch {throw Error('service_error');}
        if(!response.ok){const error=Error('service_error'); error.status=response.status; error.data=data; throw error;}
        return data;
      } finally {clearTimeout(timer); this.controller?.signal.removeEventListener('abort',abort);}
    }
    cartUrl(path){return (window.Shopify?.routes?.root || '/') + path;}
    async resolve(name) {
      const key=norm(name); if(this.memo.has(key)) return this.memo.get(key);
      await new Promise(r=>setTimeout(r, Math.max(0,this.nextScryfall-Date.now())));
      if(this.controller.signal.aborted) throw Error('cancelled');
      this.nextScryfall=Date.now()+650;
      const query='!"'+name.replace(/[\u2018\u2019]/g,"'").replace(/\\/g,'\\\\').replace(/"/g,'\\"')+'" lang:any';
      let data;
      try {data=await this.json('https://api.scryfall.com/cards/search?'+new URLSearchParams({q:query,unique:'cards',include_extras:'false'}), {credentials:'omit'});}
      catch(e){if(e.status===404){const r={key, state:'unknown', names:[name]}; this.memo.set(key,r); return r;} throw e;}
      const candidates=(data.data || []).filter(c=>c.oracle_id && c.layout!=='art_series');
      const exact=candidates.filter(c=>[c.name,c.printed_name].some(n=>n && norm(n)===key));
      const cards=exact.length ? exact : candidates;
      const ids=new Set(cards.map(c=>c.oracle_id));
      if(ids.size!==1 || data.has_more) return {key, state:'ambiguous', names:[name]};
      const c=cards[0], result={key:c.oracle_id || norm(c.name), state:'ok', canonical:c.name, names:[...new Set([c.name,c.printed_name,...(c.card_faces || []).flatMap(f=>[f.name,f.printed_name]),name])].filter(Boolean)};
      this.memo.set(key,result); return result;
    }
    async products(names) {
      const all=new Map(), query='('+names.map(n=>'title:"'+n.replace(/\\/g,'\\\\').replace(/"/g,'\\"')+'"').join(' OR ')+')';
      let pages=1;
      for(let page=1;page<=pages;page++){
        if(this.controller?.signal.aborted) throw Error('cancelled');
        const url=new URL('/search', location.origin);
        url.search=new URLSearchParams({q:query,type:'product',view:'mox-list-json',page:String(page),'options[prefix]':'none','options[unavailable_products]':'show',_mox_ts:String(Date.now())});
        const preview=new URL(location.href).searchParams.get('preview_theme_id'); if(preview) url.searchParams.set('preview_theme_id',preview);
        const data=await this.json(url, {credentials:'same-origin'});
        if(data.version!==1 || !Array.isArray(data.products) || data.pages>40) throw Error('service_error');
        pages=data.pages;
        for(const p of data.products){
          if(!matches(p.title,names)) continue;
          if(p.truncated) throw Error('service_error');
          for(const v of p.variants || []) all.set(String(v.id), {...v,id:String(v.id),productTitle:p.title,url:this.cartUrl(p.url.replace(/^[/]/,'')),image:v.image || p.image,optionNames:p.options});
        }
      }
      return [...all.values()].sort((a,b)=>a.price-b.price || a.id.localeCompare(b.id));
    }
    async suggest(name) {
      const key=norm(name), words=key.replace(/[^a-z0-9 ]/g,' ').split(/\s+/).filter(w=>w.length>=3).slice(0,5);
      if(!words.length) return [];
      const query=words.map(w=>'title:'+w.slice(0,Math.max(3,w.length-2))+'*').join(' OR ');
      const candidates=new Map();
      const roots=[window.Shopify?.routes?.root || '/', '/'];
      for(const root of [...new Set(roots)]) {
        const url=new URL(root+'search',location.origin);
        url.search=new URLSearchParams({q:query,type:'product',view:'mox-list-json','options[unavailable_products]':'hide','options[prefix]':'last',_mox_ts:String(Date.now())});
        const data=await this.json(url,{credentials:'same-origin'});
        if(data.version!==1 || !Array.isArray(data.products)) continue;
        for(const product of data.products){
          const title=cardTitle(product.title), score=distance(name,title);
          if(score===0 || score>Math.max(1,Math.min(4,Math.floor(key.length*.25)))) continue;
          if(!(product.variants || []).some(v=>v.available && Number(v.stock)>0)) continue;
          if(!candidates.has(norm(title))) candidates.set(norm(title),{name:title,score});
        }
      }
      const result=[];
      for(const candidate of [...candidates.values()].sort((a,b)=>a.score-b.score).slice(0,3)){
        const found=await this.resolve(candidate.name);
        if(found.state!=='ok') continue;
        const variants=await this.products(found.names);
        if(variants.some(v=>stock(v,bag(this.cart))>0)) result.push({...candidate,variants});
      }
      return result;
    }
    useSuggestion(group, name) {
      if(this.busy || this.locked) return;
      for(const entry of group.sources) entry.name=name;
      this.$('textarea').value=this.entries.map(e=>e.explicit ? `${e.quantity}${e.marker} ${e.name}` : e.name).join('\n');
      this.search();
    }
    async search() {
      if(this.busy || this.locked) return;
      try {this.entries=parseList(this.$('textarea').value);} catch(e){this.say(e.message); return;}
      this.controller=new AbortController(); this.groups=[]; this.busy=true; this.render();
      const byName=new Map();
      for(const e of this.entries){const k=norm(e.name); if(!byName.has(k)) byName.set(k,[]); byName.get(k).push(e);}
      let processed=0;
      try {
        this.cart=await this.json(this.cartUrl('cart.js'),{credentials:'same-origin'});
        for(const source of byName.values()){
          if(this.controller.signal.aborted) break;
          this.say('progress',{n:++processed,total:byName.size});
          let found;
          try {found=await this.resolve(source[0].name);} catch(e){if(this.controller.signal.aborted) break; found={key:norm(source[0].name),state:'error',names:[source[0].name]};}
          source.forEach(e=>e.key=found.key);
          let group=this.groups.find(g=>g.key===found.key);
          if(group){group.quantity+=source.reduce((n,e)=>n+e.quantity,0); group.sources.push(...source); continue;}
          group={...found,quantity:source.reduce((n,e)=>n+e.quantity,0),sources:source,variants:[],choices:{},added:0,capacity:0,selected:true,open:false};
          this.groups.push(group);
          if(group.state==='ok'){
            try {group.variants=await this.products(group.names);} catch(e){group.state='error';}
          }
          if(group.state==='unknown'){try{group.suggestions=await this.suggest(source[0].name);}catch{group.suggestions=[];}}
          this.allocate(); this.render();
        }
        for(const e of this.entries){if(!e.key){e.key='unverified-'+e.index;this.groups.push({key:e.key,state:'error',quantity:e.quantity,sources:[e],variants:[],choices:{},added:0,capacity:0,selected:false});}}
        this.allocate(); this.say(this.controller.signal.aborted?'cancelled':'done');
      } catch(e){this.groups=[]; this.entries=[]; this.say('service_error');}
      finally {this.busy=false; this.render();}
    }
    allocate() {
      const cart=bag(this.cart), reserved={}, filters=this.filters();
      for(const g of this.groups){
        g.choices={}; g.capacity=0;
        let need=Math.max(0,g.quantity-g.added);
        for(const v of g.variants){
          if(g.state!=='ok' || !eligible(v,filters)) continue;
          const available=Math.max(0,stock(v,cart)-(reserved[v.id] || 0));
          g.capacity+=available;
          const quantity=Math.min(need,available); g.choices[v.id]=quantity; need-=quantity;
          reserved[v.id]=(reserved[v.id] || 0)+quantity;
        }
      }
    }
    selectedItems(groups) {
      const map=new Map();
      for(const g of groups) if(g.state==='ok' && g.selected) for(const v of g.variants){const quantity=g.choices[v.id] || 0;if(quantity) map.set(v.id,{id:Number(v.id),quantity:(map.get(v.id)?.quantity || 0)+quantity});}
      return [...map.values()];
    }
    syncCartCount(cart) {
      for(const icon of document.querySelectorAll('cart-icon')) {
        try {icon.renderCartBubble?.(cart.item_count);} catch(error) {console.warn('[mox-list] Cart counter refresh failed:',error);}
      }
    }
    async beginCartUpdate(items) {
      try {
        const {CartLinesUpdateEvent,CartErrorEvent}=await import('@shopify/events');
        const update=CartLinesUpdateEvent.createPromise();
        update.promise.catch(()=>{});
        this.dispatchEvent(new CartLinesUpdateEvent({
          action:'add',context:'product',
          lines:items.map(item=>({merchandiseId:item.id,quantity:item.quantity})),
          promise:update.promise,detail:{source:'mox-magic-list'}
        }));
        return {
          resolve:(cart,sections,didError)=>{
            try {
              update.resolve({
                cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                userErrors:didError?[{code:'INVALID',message:this.t('service_error')}]:[],
                detail:{source:'mox-magic-list',sections,items:cart.items,itemCount:cart.item_count,didError}
              });
            } catch(error) {update.reject(error);this.syncCartCount(cart);}
          },
          reject:error=>{
            update.reject(error);
            this.dispatchEvent(new CartErrorEvent({error:this.t('uncertain'),code:'SERVICE_UNAVAILABLE'}));
          }
        };
      } catch(error) {console.warn('[mox-list] Cart events unavailable:',error);return null;}
    }
    async add(groups) {
      if(this.busy || this.locked) return;
      const items=this.selectedItems(groups); if(!items.length) return;
      this.controller=new AbortController(); this.busy=true; this.render(); this.say('adding');
      let added=0, failed=false, pendingUpdate=null;
      try {
        const fresh=await this.json(this.cartUrl('cart.js'),{credentials:'same-origin'});
        if(JSON.stringify(bag(fresh))!==JSON.stringify(bag(this.cart))){this.cart=fresh;this.allocate();this.say('cart_changed');return;}
        this.cart=fresh;
        for(let offset=0;offset<items.length;offset+=20){
          const batch=items.slice(offset,offset+20), before=bag(this.cart,this.token);
          const sections=[...new Set([...document.querySelectorAll('cart-items-component')].map(el=>el.dataset.sectionId).filter(Boolean))].slice(0,5);
          pendingUpdate=null;
          let postError=false, response;
          try {response=await this.json(this.cartUrl('cart/add.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:batch.map(i=>({...i,properties:{_mox_list:this.token}})),...(sections.length?{sections,sections_url:window.location.pathname}:{})})});}
          catch(e){postError=true;}
          let after;
          try {after=await this.json(this.cartUrl('cart.js'),{credentials:'same-origin'});} catch(e){pendingUpdate?.reject(e);pendingUpdate=null;this.locked=true;this.say('uncertain');return;}
          this.cart=after; const receipt=bag(after,this.token);
          for(const item of batch){
            const received=Math.max(0,Math.min(item.quantity,(receipt[item.id] || 0)-(before[item.id] || 0)));
            let left=received; added+=received;
            for(const g of groups){const portion=Math.min(left,g.choices[item.id] || 0);g.added+=portion;left-=portion;}
            if(received!==item.quantity) postError=true;
          }
          if(pendingUpdate) pendingUpdate.resolve(after,postError?undefined:response?.sections,postError);
          else this.syncCartCount(after);
          pendingUpdate=null;
          if(postError){failed=true;break;}
        }
        if(failed) for(const g of groups){try{g.variants=await this.products(g.names);}catch{g.state='error';}}
        this.allocate(); this.say(failed?'partial_add':'added',{n:added});
      } catch(e){this.say('service_error');}
      finally {pendingUpdate?.reject(Error('service_error'));this.busy=false;this.render();}
    }
    element(tag,text,cls){const e=document.createElement(tag);if(text!==undefined)e.textContent=text;if(cls)e.className=cls;return e;}
    render() {
      const count=this.groups.length, controlsDisabled=this.busy || this.locked;
      this.$('fieldset').disabled=controlsDisabled;
      this.$('[data-example]').disabled=controlsDisabled;
      this.$('[data-cancel]').hidden=!this.busy;
      this.$('[data-cancel]').disabled=this.busy && this.$('[data-status]').textContent===this.t('adding');
      const list=this.$('[data-results]'); list.replaceChildren();
      let selected=0,total=0,missing=0,unverified=0;
      const filters=this.filters(), cart=bag(this.cart);
      for(const [index,g] of this.groups.entries()){
        const wanted=g.quantity-g.added, shortage=Math.max(0,wanted-(g.state==='ok'?g.capacity:0)); missing+=shortage;
        if(g.state!=='ok') unverified+=wanted;
        const chosen=g.selected?Object.values(g.choices).reduce((a,b)=>a+b,0):0; selected+=chosen;
        const cost=g.variants.reduce((s,v)=>s+(g.selected?(g.choices[v.id] || 0)*v.price:0),0); total+=cost;
        const card=this.element('article',undefined,'mox-list-card');
        const head=this.element('div',undefined,'mox-list-card-head');
        const image=g.variants.find(v=>v.image)?.image;
        if(image){const img=this.element('img');img.src=image;img.alt='';img.width=72;img.height=101;img.loading='lazy';head.append(img);}
        const info=this.element('div',undefined,'mox-list-card-info');
        const label=this.element('label',undefined,'mox-list-card-title'), checkbox=this.element('input');checkbox.type='checkbox';checkbox.checked=g.selected && g.state==='ok' && g.capacity>0 && wanted>0;checkbox.disabled=controlsDisabled || !g.capacity || !wanted;
        checkbox.onchange=()=>{g.selected=checkbox.checked;this.render();};
        label.append(checkbox,document.createTextNode(g.sources[0].name));info.append(label);
        if(g.canonical && norm(g.canonical)!==norm(g.sources[0].name)) info.append(this.element('small',g.canonical));
        info.append(this.element('p',this.t('quantities',{asked:g.quantity,added:g.added,available:Math.min(g.capacity,wanted)})));
        const badge=g.state==='ok'?(shortage?(g.capacity?'partial':'unavailable'):'available'):g.state;
        const badgeElement=this.element('span',this.t(badge,{n:shortage}),'mox-list-badge'+(g.state==='unknown'?' mox-list-error':''));
        if(g.state==='unknown') badgeElement.setAttribute('role','alert');
        info.append(badgeElement);
        if(g.state==='unknown') for(const suggestion of g.suggestions || []){
          const available=suggestion.variants.find(v=>eligible(v,filters) && stock(v,cart)>0);
          if(!available) continue;
          const box=this.element('div',undefined,'mox-list-suggestion');
          if(available.image){const thumbnail=this.element('img');thumbnail.src=available.image;thumbnail.alt='';thumbnail.width=32;thumbnail.height=45;box.append(thumbnail);}
          box.append(this.element('span',this.t('suggestion',{name:suggestion.name})));
          const accept=this.element('button',this.t('suggestion_apply'));accept.type='button';accept.disabled=controlsDisabled;accept.onclick=()=>this.useSuggestion(g,suggestion.name);box.append(accept);info.append(box);
        }
        head.append(info);
        const action=this.element('div',undefined,'mox-list-card-action');
        if(chosen){
          const prices=new Map();
          for(const v of g.variants){const quantity=g.choices[v.id] || 0;if(quantity)prices.set(v.price,(prices.get(v.price)||0)+quantity);}
          const breakdown=this.element('div',undefined,'mox-list-price-detail');
          for(const [price,quantity] of prices)breakdown.append(this.element('span',quantity+' × '+this.money(price)));
          action.append(breakdown);
        }
        action.append(this.element('strong',g.variants.length?this.money(cost):'\u2014'));
        const button=this.element('button',this.t('add_card'));button.type='button';button.disabled=controlsDisabled || !chosen;button.onclick=()=>this.add([g]);action.append(button);head.append(action);card.append(head);
        if(g.variants.length){
          const details=this.element('details');details.open=!!g.open;details.ontoggle=()=>g.open=details.open;
          details.append(this.element('summary',this.t('versions',{n:g.variants.length})));
          const table=this.element('table');const caption=this.element('caption',this.t('version_help'));table.append(caption);
          const thead=this.element('thead'), hr=this.element('tr');
          ['version','language','condition','price','quantity'].forEach(key=>{const th=this.element('th',this.t(key));th.scope='col';hr.append(th);});thead.append(hr);table.append(thead);
          const tbody=this.element('tbody');
          for(const v of g.variants){
            const m=metadata(v), tr=this.element('tr'), version=this.element('td'), link=this.element('a',v.productTitle+' / '+m.finish);
            link.href=v.url+(v.url.includes('?')?'&':'?')+'variant='+v.id;link.target='_blank';link.rel='noopener';link.className='mox-list-version-link';
            if(v.image){const thumbnail=this.element('img',undefined,'mox-list-version-thumb');thumbnail.src=v.image;thumbnail.alt='';thumbnail.width=24;thumbnail.height=34;thumbnail.loading='lazy';link.prepend(thumbnail);}
            version.append(link);tr.append(version,this.element('td',m.language),this.element('td',m.condition),this.element('td',this.money(v.price)));
            const cell=this.element('td'), input=this.element('input');input.type='number';input.min='0';input.step='1';input.value=String(g.choices[v.id] || 0);input.setAttribute('aria-label',this.t('quantity')+' '+v.productTitle+' '+v.title);input.inputMode='numeric';
            const free=stock(v,cart), allowed=eligible(v,filters), chosenTotal=Object.values(g.choices).reduce((a,b)=>a+b,0);
            input.max=String(Math.min(free,Math.max(0,wanted-chosenTotal+(g.choices[v.id] || 0))));
            input.disabled=controlsDisabled || !allowed || !g.selected || !free || !wanted;
            input.onchange=()=>{g.choices[v.id]=Math.max(0,Math.min(Number(input.max),Math.floor(Number(input.value) || 0)));g.open=true;this.render();};
            cell.append(input,this.element('small',allowed?this.t('stock',{n:free}):this.t('excluded')));tr.append(cell);tbody.append(tr);
          }
          table.append(tbody);const wrap=this.element('div',undefined,'mox-list-table-wrap');wrap.append(table);details.append(wrap);card.append(details);
        }
        list.append(card);
      }
      this.$('[data-summary]').textContent=this.t('summary',{cards:count,selected,total:this.money(total),missing});
      this.$('[data-unverified]').textContent=unverified?this.t('unverified',{n:unverified}):'';
      this.$('[data-add-all]').disabled=controlsDisabled || !selected;
      this.$('[data-copy]').disabled=controlsDisabled || !missing;
      this.$('[data-download]').disabled=controlsDisabled || !missing;
      this.$('[data-output]').hidden=!count;
    }
    async export(download) {
      const text=missingText(this.entries,this.groups); if(!text) return;
      if(download){const url=URL.createObjectURL(new Blob(['\ufeff'+text+'\n'],{type:'text/plain;charset=utf-8'})), a=this.element('a');a.href=url;a.download='moxcards-cartes-manquantes.txt';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);}
      else try{await navigator.clipboard.writeText(text);this.say('copied');}
      catch{const area=this.$('[data-export]');area.hidden=false;area.value=text;area.focus();area.select();this.say('copy_manual');}
    }
  }
  if(!customElements.get('mox-magic-list'))customElements.define('mox-magic-list',MoxMagicList);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moxcards-home-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moxcards-home-carousel')) {
    // Measure every pending carousel before applying any layout-affecting writes.
    const pending = new Set();
    let frame = 0;
    let initialProductPrioritized = false;
    const scheduleUpdate = (carousel) => {
      pending.add(carousel);
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const carousels = [...pending];
        pending.clear();
        const measurements = carousels.map(carousel => [carousel, carousel.measure()]);
        for (const [carousel, measurement] of measurements) {
          if (measurement && carousel.isConnected) carousel.apply(measurement);
        }
      });
    };
    class MoxcardsHomeCarousel extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        pending.delete(this);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.childObserver?.disconnect();
        this.imageObserver?.disconnect();
      }
      setup() {
        if (!this.isConnected) return;
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.childObserver?.disconnect();
        this.imageObserver?.disconnect();
        this.viewport = this.querySelector('[data-mox-viewport]');
        this.previous = this.querySelector('[data-mox-previous]');
        this.next = this.querySelector('[data-mox-next]');
        if (!this.viewport || !this.previous || !this.next) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.geometryDirty = true;
        this.sizedImages = new WeakSet();
        const schedule = () => scheduleUpdate(this);
        const invalidate = () => {
          this.geometryDirty = true;
          this.sizedImages = new WeakSet();
          schedule();
        };
        this.viewport.addEventListener('scroll', () => {
          const remaining = this.viewport.scrollWidth - this.viewport.clientWidth - Math.abs(this.viewport.scrollLeft);
          if (Math.abs(this.viewport.scrollLeft) > 1 && remaining < this.viewport.clientWidth) this.revealCards();
          schedule();
        }, { passive: true, signal });
        this.viewport.addEventListener('touchstart', () => this.revealCards(), { passive: true, signal });
        this.viewport.addEventListener('wheel', event => {
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || event.shiftKey) this.revealCards();
        }, { passive: true, signal });
        this.viewport.addEventListener('focusin', event => {
          const card = event.target.closest('.resource-list__item');
          const cards = [...this.viewport.querySelectorAll(':scope > .resource-list__item')];
          if (card && cards.indexOf(card) >= cards.length - 2) this.revealCards();
        }, { signal });
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport) return;
          const rtl = getComputedStyle(this.viewport).direction === 'rtl';
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            if (event.key === 'End') this.revealCards(Infinity);
            this.viewport.scrollTo({ left: event.key === 'Home' ? 0 : (rtl ? -1 : 1) * this.viewport.scrollWidth, behavior: 'auto' });
          }
        }, { signal });
        this.resizeObserver = new ResizeObserver(invalidate);
        this.resizeObserver.observe(this.viewport);
        const media = this.viewport.querySelector('.card-gallery, .mox-new-singles__media');
        if (media) this.resizeObserver.observe(media);
        this.childObserver = new MutationObserver(invalidate);
        this.childObserver.observe(this.viewport, { childList: true });
        // Promote only images intersecting both the carousel and the viewport.
        // Native lazy loading remains the fallback and handles all other images.
        this.nearViewport = false;
        this.preloadDistance = 0;
        const connection = navigator.connection;
        if ('IntersectionObserver' in window && !connection?.saveData && !/^(slow-)?2g$/.test(connection?.effectiveType || '')) {
          const scrollLayout = window.matchMedia('(min-width: 990px)');
          const observeImages = () => {
            this.imageObserver?.disconnect();
            this.nearViewport = false;
            this.imageObserver = new IntersectionObserver(entries => {
              this.nearViewport = entries.some(entry => entry.isIntersecting);
              if (this.nearViewport) schedule();
            }, {
              root: scrollLayout.matches ? document.querySelector('.page-wrapper') : null,
              rootMargin: this.preloadDistance + 'px 0px'
            });
            this.imageObserver.observe(this);
          };
          scrollLayout.addEventListener('change', observeImages, { signal });
          observeImages();
        }
        this.setAttribute('data-mox-ready', 'true');
        schedule();
      }
      measure() {
        if (!this.isConnected || !this.viewport) return;
        const imageUpdates = this.measureNearbyImages();
        const media = this.geometryDirty ? this.viewport.querySelector('.card-gallery, .mox-new-singles__media') : null;
        let mediaCenter;
        if (media) {
          if (this.observedMedia !== media) {
            if (this.observedMedia) this.resizeObserver.unobserve(this.observedMedia);
            this.observedMedia = media;
            this.resizeObserver.observe(media);
          }
          const bounds = media.getBoundingClientRect();
          mediaCenter = bounds.top - this.getBoundingClientRect().top + bounds.height / 2;
        }
        this.geometryDirty = false;
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const position = Math.min(maximum, Math.abs(this.viewport.scrollLeft));
        return { imageUpdates, mediaCenter, maximum, position };
      }
      apply({ imageUpdates, mediaCenter, maximum, position }) {
        if (mediaCenter !== undefined) {
          const nextCenter = mediaCenter + 'px';
          if (this.style.getPropertyValue('--mox-media-center') !== nextCenter) this.style.setProperty('--mox-media-center', nextCenter);
        }
        const previousDisabled = maximum <= 2 || position <= 2;
        const nextDisabled = !this.hasPendingCards() && (maximum <= 2 || position >= maximum - 2);
        if (this.previous.disabled !== previousDisabled) this.previous.disabled = previousDisabled;
        if (this.next.disabled !== nextDisabled) this.next.disabled = nextDisabled;
        for (const {image, sizes, prioritize} of imageUpdates) {
          if (prioritize && !initialProductPrioritized) {
            image.fetchPriority = 'high';
            initialProductPrioritized = true;
          }
          if (image.sizes !== sizes) image.sizes = sizes;
          this.sizedImages.add(image);
          if (image.loading === 'lazy') image.loading = 'eager';
        }
      }
      measureNearbyImages() {
        const updates = [];
        if (!this.nearViewport) return updates;
        const viewport = this.viewport.getBoundingClientRect();
        if (!viewport.width || viewport.bottom < -this.preloadDistance || viewport.top > window.innerHeight + this.preloadDistance) return updates;
        const cards = this.viewport.querySelectorAll(':scope > .resource-list__item');

        for (const card of cards) {

          // Keep alternate product views and zoom images deferred.
          const image = card.querySelector('.card-gallery img.product-media__image, .mox-new-singles__card img');
          if (!image || (this.sizedImages.has(image) && image.loading !== 'lazy')) continue;
          // Once promoted from lazy, sizes=auto no longer applies. Use the
          // rendered slot instead of an oversized generic viewport fallback.
          const imageBounds = image.getBoundingClientRect();
          if (imageBounds.right <= Math.max(0, viewport.left) || imageBounds.left >= Math.min(window.innerWidth, viewport.right) || imageBounds.bottom <= Math.max(0, viewport.top) || imageBounds.top >= Math.min(window.innerHeight, viewport.bottom)) continue;
          let renderedWidth = imageBounds.width;
          const intrinsicWidth = Number(image.getAttribute('width')) || image.naturalWidth;
          const intrinsicHeight = Number(image.getAttribute('height')) || image.naturalHeight;
          if (intrinsicWidth > 0 && intrinsicHeight > 0 && getComputedStyle(image).objectFit === 'contain') {
            renderedWidth = Math.min(renderedWidth, imageBounds.height * intrinsicWidth / intrinsicHeight);
          }
          const slot = Math.ceil(renderedWidth);
          if (!slot) continue;
          const sizes = slot + 'px';
          const prioritize = !initialProductPrioritized && window.innerWidth < 750 && window.scrollY === 0;
          updates.push({image, sizes, prioritize});
        }
        return updates;
      }
      hasPendingCards() {
        const pendingCards = this.viewport?.querySelector('[data-mox-pending-cards]');
        return pendingCards?.tagName === 'TEMPLATE'
          ? Boolean(pendingCards.content.firstElementChild)
          : Boolean(pendingCards?.textContent.trim());
      }
      preparePendingCards() {
        let template = this.viewport?.querySelector('template[data-mox-pending-cards]');
        const fallback = this.viewport?.querySelector('noscript[data-mox-pending-cards]');
        if (!template && fallback) {
          template = document.createElement('template');
          template.dataset.moxPendingCards = '';
          template.innerHTML = fallback.textContent;
          template.content.querySelector('[data-mox-nojs-style]')?.remove();
          fallback.replaceWith(template);
        }
        return template;
      }
      revealCards(limit = Number(this.dataset.initialCards) || 6) {
        const template = this.preparePendingCards();
        if (!template) return;
        const additions = [];
        while (template.content.firstElementChild && additions.length < limit) {
          const card = template.content.firstElementChild;
          card.remove();
          additions.push(card);
        }
        template.before(...additions);
        if (!template.content.firstElementChild) template.remove();
        if (additions.length) {
          this.geometryDirty = true;
          scheduleUpdate(this);
        }
      }
      appendProgressiveCards(cards) {
        if (!this.viewport) this.viewport = this.querySelector('[data-mox-viewport]');
        if (!this.viewport) return;
        let template = this.preparePendingCards();
        const initial = Number(this.dataset.initialCards) || 6;
        let count = this.viewport.querySelectorAll(':scope > .resource-list__item').length;
        const additions = [];
        for (const card of cards) {
          if (count < initial && !template) {
            additions.push(card);
            count++;
          } else {
            if (!template) {
              template = document.createElement('template');
              template.dataset.moxPendingCards = '';
              this.viewport.append(template);
            }
            template.content.append(card);
          }
        }
        if (template) template.before(...additions);
        else this.viewport.append(...additions);
        this.geometryDirty = true;
        if (this.previous && this.next) scheduleUpdate(this);
      }
      move(direction) {
        if (direction > 0) this.revealCards();
        const card = this.viewport.querySelector(':scope > .resource-list__item');
        if (!card) return;
        const style = getComputedStyle(this.viewport);
        const stride = card.getBoundingClientRect().width + (Number.parseFloat(style.columnGap) || 0);
        const sign = style.direction === 'rtl' ? -1 : 1;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollBy({ left: direction * sign * stride, behavior });
      }
    }
    customElements.define('moxcards-home-carousel', MoxcardsHomeCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moxcards-product-ui"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('moxcards-stock-select')) return;
  class MoxcardsStockSelect extends HTMLElement {
    async connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.control = this.closest('quantity-selector-component');
      this.input = this.control?.querySelector('input[ref="quantityInput"]');
      this.select = this.querySelector('select');
      this.productForm = this.closest('product-form-component');
      this.form = this.closest('form');
      this.pending = 0;
      this.generation = 0;
      this.optionsKey = null;
      if (!this.control || !this.input || !this.select) return;
      try {
        const [, { StandardEvents }] = await Promise.all([
          customElements.whenDefined('quantity-selector-component'),
          import('@shopify/events'),
        ]);
        if (signal.aborted || !this.isConnected) return;
        this.select.addEventListener('change', () => {
          this.input.value = this.select.value;
          this.control.onQuantityChange();
          this.control.updateButtonStates();
          this.sync();
        }, { signal });
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.input, { attributes: true, attributeFilter: ['min', 'max', 'step', 'disabled', 'data-cart-quantity'] });
        this.form?.addEventListener('submit', (event) => {
          if (this.pending || this.exhausted() || this.input.disabled || this.control.canAddToCart?.().canAdd === false) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { signal, capture: true });
        const scope = this.closest('product-card, dialog, .shopify-section');
        scope?.addEventListener(StandardEvents.productSelect, async (event) => {
          const sourceCard = event.target instanceof Element ? event.target.closest('product-card') : null;
          if (sourceCard && !sourceCard.contains(this)) return;
          if (!event.promise) return;
          const generation = ++this.generation;
          this.pending++;
          this.sync();
          try {
            const { detail } = await event.promise;
            if (signal.aborted || generation !== this.generation) return;
            const incomingForm = [...(detail?.html?.querySelectorAll('product-form-component') || [])].find(
              (form) => form.dataset.productId === this.productForm?.dataset.productId
            );
            const incoming = incomingForm?.querySelector('quantity-selector-component');
            const input = incoming?.querySelector('input[ref="quantityInput"]');
            if (!input) return;
            this.control.dataset.variantId = incoming.dataset.variantId || '';
            this.input.disabled = input.disabled;
            this.control.setCartQuantity(Number(input.dataset.cartQuantity) || 0);
            this.control.updateConstraints(input.min, input.max || null, input.step);
          } catch (error) {
            if (error?.name !== 'AbortError') console.warn('[moxcards-stock] Variant refresh failed', error);
          } finally {
            this.pending = Math.max(0, this.pending - 1);
            if (!signal.aborted) this.sync();
          }
        }, { signal });
        document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
          if (!event.promise) return;
          this.pending++;
          this.sync();
          try {
            const result = await event.promise;
            if (signal.aborted) return;
            let items = result?.detail?.items;
            if (!Array.isArray(items)) {
              const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store', signal, headers: { Accept: 'application/json' } });
              if (!response.ok) throw new Error(`Cart refresh failed: ${response.status}`);
              items = (await response.json()).items;
            }
            if (!Array.isArray(items)) return;
            queueMicrotask(() => {
              if (signal.aborted) return;
              const id = this.productForm?.querySelector('input[name="id"]')?.value || this.control.dataset.variantId;
              const quantity = items.reduce((sum, item) => String(item.variant_id ?? item.id) === String(id) ? sum + Number(item.quantity || 0) : sum, 0);
              this.control.setCartQuantity(quantity);
              this.sync();
            });
          } catch (error) {
            if (error?.name !== 'AbortError') console.warn('[moxcards-stock] Cart refresh failed', error);
          } finally {
            this.pending = Math.max(0, this.pending - 1);
            if (!signal.aborted) this.sync();
          }
        }, { signal });
        this.sync();
      } catch (error) {
        console.warn('[moxcards-stock] Native quantity input retained', error);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
    limits() {
      const max = Number.parseInt(this.input.max, 10);
      const min = Math.max(1, Number.parseInt(this.input.min, 10) || 1);
      const step = Math.max(1, Number.parseInt(this.input.step, 10) || 1);
      const cart = Math.max(0, Number.parseInt(this.input.dataset.cartQuantity, 10) || 0);
      return { max, min, step, remaining: Number.isFinite(max) ? Math.max(0, max - cart) : Infinity };
    }
    exhausted() {
      const { min, remaining } = this.limits();
      return remaining < min;
    }
    sync() {
      const { max, min, step, remaining } = this.limits();
      const limited = Number.isFinite(max);
      const empty = remaining < min;
      this.control.classList.toggle('moxcards-stock-limited', limited);
      this.hidden = !limited;
      if (limited) {
        const key = `${min}:${step}:${remaining}`;
        if (key !== this.optionsKey) {
          const options = document.createDocumentFragment();
          if (empty) options.append(new Option('0', '0'));
          else for (let value = min; value <= remaining; value += step) options.append(new Option(String(value), String(value)));
          this.select.replaceChildren(options);
          this.optionsKey = key;
        }
        if (!empty) {
          const largest = min + Math.floor((remaining - min) / step) * step;
          const current = Math.max(min, Number.parseInt(this.input.value, 10) || min);
          const value = Math.min(largest, min + Math.floor((current - min) / step) * step);
          this.input.value = String(value);
          this.select.value = String(value);
        }
        this.select.disabled = empty || this.input.disabled || this.pending > 0;
      }
      const blocked = empty || this.input.disabled || this.pending > 0;
      const buttons = [...(this.productForm?.querySelectorAll('button[ref="addToCartButton"]') || [])];
      if (this.productForm && !this.closest('product-card, .quick-add-modal')) {
        document.querySelectorAll('sticky-add-to-cart').forEach((sticky) => {
          if (sticky.dataset.productId === this.productForm.dataset.productId) buttons.push(...sticky.querySelectorAll('button[ref="addToCartButton"]'));
        });
      }
      for (const button of buttons) {
        if (blocked && !button.disabled) {
          button.dataset.moxcardsStockBlocked = 'true';
          button.disabled = true;
        } else if (!blocked && button.dataset.moxcardsStockBlocked === 'true') {
          delete button.dataset.moxcardsStockBlocked;
          button.disabled = false;
        }
      }
      const accelerated = this.productForm?.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
      if (accelerated) {
        if (blocked && !accelerated.hidden) {
          accelerated.dataset.moxcardsStockBlocked = 'true';
          accelerated.hidden = true;
        } else if (!blocked && accelerated.dataset.moxcardsStockBlocked === 'true') {
          delete accelerated.dataset.moxcardsStockBlocked;
          accelerated.hidden = false;
        }
      }
    }
  }
  customElements.define('moxcards-stock-select', MoxcardsStockSelect);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mtg-collection-filters"] && !Shopify.designMode) return;
  try {
    (() => {
  const controllerKey = '__moxResponsiveDetailsV1';
  if (window[controllerKey]) {
    window[controllerKey].init(document);
    return;
  }

  const selector = 'details.mox-mtg-advanced, details.mox-vault-mobile-details';
  const media = window.matchMedia('(min-width: 750px)');
  const states = new WeakMap();

  function sync(details, state) {
    const desktop = media.matches;
    if (state.desktop === desktop) return;
    const previousDesktop = state.desktop;
    if (desktop) {
      if (previousDesktop === false) state.mobileOpen = details.open;
      state.desktop = true;
      details.open = true;
      details.dataset.moxDesktopOpen = 'true';
    } else {
      state.desktop = false;
      delete details.dataset.moxDesktopOpen;
      if (previousDesktop === true) {
        const restoreFocus = !state.mobileOpen && details.contains(document.activeElement);
        details.open = state.mobileOpen;
        if (restoreFocus) details.querySelector('summary')?.focus({ preventScroll: true });
      }
    }
  }

  function bind(details) {
    let state = states.get(details);
    if (!state) {
      state = { mobileOpen: details.dataset.moxInitialMobileOpen === undefined ? details.open : details.dataset.moxInitialMobileOpen === 'true', desktop: null };
      delete details.dataset.moxInitialMobileOpen;
      states.set(details, state);
      details.addEventListener('toggle', () => {
        if (state.desktop === false) state.mobileOpen = details.open;
      });
    }
    sync(details, state);
  }

  function init(root = document) {
    if (root instanceof Element && root.matches(selector)) bind(root);
    root.querySelectorAll(selector).forEach(bind);
  }

  window[controllerKey] = { init };
  media.addEventListener('change', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('pageshow', () => init(document));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
